import styled from '@emotion/styled'
import { Locale, Translation } from 'locale'
import * as constants from 'view/styles/constants'

export const DefaultPlaceholder = styled.div`
  font-size: 20px;
  font-family: NEXWeb;
  font-weight: ${constants.FontWeight.Medium};
  color: lightgray;
`

DefaultPlaceholder.defaultProps = {
  children: Locale.translate(Translation.TC_NO_DATA)
}
